var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDv360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipdv360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 18.184C15.9627 17.4186 15.9846 16.6515 16.0656 15.8893C16.1788 15.1326 16.4813 14.4159 16.9456 13.8043C17.41 13.1928 18.0215 12.7057 18.7245 12.3876C19.4276 12.0694 20.1998 11.9301 20.9711 11.9824C21.7424 12.0348 22.4882 12.277 23.1408 12.6872C29.1022 16.0449 35.1554 19.4416 41.1562 22.8252C42.7808 23.7327 44.3793 24.6791 46.004 25.5996C44.2512 25.9908 42.5713 26.6514 41.0252 27.5572C39.3403 28.6559 37.5389 29.5688 35.6533 30.2797C32.1419 28.4647 28.8795 26.2608 25.3026 24.6532C24.7785 24.3291 24.2413 24.0309 23.7304 23.6938C21.1099 21.9307 17.7689 21.1528 16.0001 18.184Z",
    fill: "#48BA76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6532 30.2797C37.5389 29.5688 39.3402 28.6559 41.0251 27.5572C42.5712 26.6514 44.2512 25.9909 46.0039 25.5996C46.7035 25.939 47.3817 26.32 48.0347 26.7405C48.6634 27.1617 49.174 27.7337 49.5188 28.403C49.8636 29.0723 50.0314 29.8172 50.0066 30.568C49.9817 31.3189 49.765 32.0513 49.3767 32.6969C48.9883 33.3424 48.441 33.8801 47.7858 34.2597C40.4617 38.4861 33.0328 42.6087 25.6825 46.7573C25.4016 46.8759 25.1067 46.9586 24.8047 47.0036C25.2544 45.7089 25.4284 44.3362 25.3157 42.9717V42.2587V36.1266C27.7134 34.8302 30.1373 33.5337 32.5087 32.2373C33.688 31.8183 34.761 31.1503 35.6532 30.2797Z",
    fill: "#76CA96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3549 36.1266V42.2587H25.0929C21.5029 38.0583 17.1006 39.7955 16 43.231V18.1841C17.7688 21.1529 21.1098 21.9308 23.7303 23.668C24.2412 24.005 24.7784 24.3032 25.3025 24.6273C25.3287 28.4734 25.3462 32.3065 25.3549 36.1266Z",
    fill: "#01A955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 43.231C17.0481 39.7955 21.4504 38.0453 25.0011 42.3106L25.2631 42.9718C25.3927 44.3326 25.2366 45.7053 24.8045 47.0036C24.2249 47.6653 23.4992 48.186 22.6835 48.5254C21.8678 48.8649 20.9841 49.014 20.1009 48.9612C17.3101 48.6112 15.8689 46.498 15.9999 43.231Z",
    fill: "#029041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3158 42.9717L25.0537 42.3105H25.3158V42.9717Z",
    fill: "#48BA76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipdv360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 37,
    fill: "white",
    transform: "translate(16 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDv360);
export default __webpack_public_path__ + "static/media/dv360.69f7a1d2c27a934d4a0283cfe704f318.svg";
export { ForwardRef as ReactComponent };